// extracted by mini-css-extract-plugin
module.exports = {"sm":"576px","md":"768px","lg":"992px","xl":"1200px","xxl":"1440px","spacing":"4px","notFound":"PageNotFound_notFound__3C7cI","backToHome":"PageNotFound_backToHome__3AmvG"};